export default "__VITE_ASSET__r13F0R_h__"